<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Starter page component
 */
export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Starter page",
            items: [
                {
                    text: "Utility",
                    href: "/",
                },
                {
                    text: "Starter page",
                    active: true,
                },
            ],
            loading: false,
            appid: "",
            userinfo: [],
            free: {},
            swiper: [],
            swipertype: [
                {
                    key: "image",
                    name: "图片"
                }
            ],
            progress: 0,
            loadingtext: "加载中..."
        };
    },
    mounted() {
        this.userinfo = JSON.parse(localStorage.getItem("user"));
        this.appid = this.$route.params.appid;
        this.title = "首页轮播图";
        this.items = [
            {
                text: this.$t("menuitems.micoapp.text"),
                href: "/",
            },
            {
                text: this.$t("menuitems.icp.micoapp.list"),
                href: "/micoapp",
            },
            {
                text: this.$t("menuitems.icp.micoapp.info"),
                href: `/micoapp/${this.appid}`,
            },
            {
                text: "首页轮播图",
                active: true,
            },
        ];
        this.getmicoappmenu();
    },
    methods: {
        getmicoappmenu() {
            var that = this;
            that.loading = true;
            that.$axios
                .post(
                    "https://api.aicoiot.com/micoappapi.php",
                    {
                        action: "micoapp.swiper",
                        appid: that.$route.params.appid,
                    },
                    {
                        headers: { Openid: that.userinfo.openid },
                    }
                )
                .then(function (response) {
                    that.loading = false;
                    that.swiper = response.data.data;
                })
                .catch(function (error) {
                    that.loading = false;
                    that.$notify.error({
                        title: '请求错误',
                        message: error
                    });
                });
        },
        save_micoappsetting(data) {
            var that = this;
            that.loading = true;
            that.$axios
                .post(
                    "https://api.aicoiot.com/micoappapi.php",
                    {
                        action: "micoapp.saveswiper",
                        appid: that.$route.params.appid,
                        id: data.id,
                        datas: data
                    },
                    {
                        headers: { Openid: that.userinfo.openid },
                    }
                )
                .then(function (response) {
                    that.loading = false;
                    if (response.data.status == 200) {
                        that.$message.success({
                            message: "保存成功"
                        });
                        that.getmicoappmenu();
                    } else {
                        that.$message.error({
                            message: response.data.message
                        });
                    }
                })
                .catch(function (error) {
                    that.loading = false;
                    that.$notify.error({
                        title: '请求错误',
                        message: error
                    });
                });
        },
        addrow_charge_sale() {
            this.swiper.push({ "id": this.swiper.length + 1, "index": 1, "type": "image", "imgUrl": null })
        },
        delete_micoappsetting(rows) {
            var that = this;
            that.$confirm('此操作将永久删除此图片，是否继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.loading = true;
                that.$axios
                    .post(
                        "https://api.aicoiot.com/micoappapi.php",
                        {
                            action: "micoapp.deleteswiper",
                            appid: that.$route.params.appid,
                            id: rows.id
                        },
                        {
                            headers: { Openid: that.userinfo.openid },
                        }
                    )
                    .then(function (response) {
                        that.loading = false;
                        if (response.data.status == 200) {
                            that.$message.success({
                                message: "删除成功"
                            });
                            that.getmicoappmenu();
                        } else {
                            that.$message.error({
                                message: response.data.message
                            });
                        }
                    })
                    .catch(function (error) {
                        that.loading = false;
                        that.$notify.error({
                            title: '请求错误',
                            message: error
                        });
                    });
            }).catch(() => {

            });

        },
        uploadimg(file, fileList) {
            console.log(file, fileList);
        },
        handleAvatarSuccess(response, file, row) {
            this.loading = false;
            this.progress = 0;
            // row.imgUrl = URL.createObjectURL(file.raw); // 更新图片URL
            row.imgUrl = response.url;
            // console.log(row);
            // console.log(response);
            this.showNotification('上传成功', '图片上传成功', 'success');
        },
        handleError() {
            this.loading = false;
            this.progress = 0;
            this.showNotification('上传失败', '图片上传失败', 'error');
        },
        handleProgress(event) {
            this.progress = Math.round((event.percent || 0));
            this.loadingtext = `正在上传: ${this.progress}%`;
            if (this.progress == 100) {
                this.loadingtext = "加载中...";
            }
        },
        beforeAvatarUpload(file) {
            this.loading = true;
            this.progress = 0;
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.showNotification('错误', '上传图片格式必须是 JPG 或 PNG!', 'error');
                this.loading = false;
                return false;
            }
            if (!isLt2M) {
                this.showNotification('错误', '上传图片大小不能超过 2MB!', 'error');
                this.loading = false;
                return false;
            }
            return true;
        },
        showNotification(title, message, type) {
            this.$message({
                message: `${message}`,
                type: `${type}`
            });
            // this.$notify[type]({
            //     title: title,
            //     message: message
            // });
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="micoapp-page micoapp-home">
            <div class="row" v-loading="loading" :element-loading-text="loadingtext"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <div class="col-12">
                    <div class="micoapp-home-toolbar">
                        <div class="micoapp-toolbar-title">
                            <h5>首页轮播图</h5>
                        </div>
                        <el-button @click="addrow_charge_sale" type="success" icon="el-icon-plus" size="small">
                            添加轮播图
                        </el-button>
                    </div>
                    <el-alert type="info" :closable="false" class="micoapp-home-alert">
                        <template slot="title">图片推荐尺寸 700×1000px，格式 JPG/PNG，大小不超过 2MB</template>
                    </el-alert>
                    <!-- 轮播图卡片网格 -->
                    <div class="micoapp-swiper-grid">
                        <div
                            v-for="(item, idx) in swiper"
                            :key="item.id || idx"
                            class="micoapp-swiper-card"
                        >
                            <div class="micoapp-swiper-card-inner">
                                <div class="micoapp-swiper-preview">
                                    <el-upload
                                        class="micoapp-swiper-uploader"
                                        action="https://api.aicoiot.com/uploadfile.php"
                                        :show-file-list="false"
                                        :on-success="(res, file) => handleAvatarSuccess(res, file, item)"
                                        :on-error="handleError"
                                        :on-progress="handleProgress"
                                        :before-upload="beforeAvatarUpload"
                                        :disabled="loading"
                                    >
                                        <img v-if="item.imgUrl" :src="item.imgUrl" class="micoapp-swiper-img" alt="">
                                        <div v-else class="micoapp-swiper-placeholder">
                                            <i class="el-icon-plus"></i>
                                            <span>上传图片</span>
                                        </div>
                                    </el-upload>
                                </div>
                                <div class="micoapp-swiper-meta">
                                    <div class="micoapp-swiper-sort">
                                        <span class="micoapp-swiper-label">排序</span>
                                        <el-input v-model.number="item.index" type="number" size="mini" style="width: 70px" />
                                    </div>
                                    <div class="micoapp-swiper-actions">
                                        <el-button type="primary" size="mini" @click="save_micoappsetting(item)">
                                            保存
                                        </el-button>
                                        <el-button type="text" size="mini" class="text-danger" @click="delete_micoappsetting(item)">
                                            移除
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="swiper.length === 0" class="micoapp-home-empty">
                        <i class="el-icon-picture-outline"></i>
                        <p>暂无轮播图，点击「添加轮播图」创建</p>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<style scoped>
.micoapp-home-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
}
.micoapp-home-toolbar .micoapp-toolbar-title h5 {
    margin: 0;
    font-weight: 700;
}

.micoapp-home-alert {
    margin-bottom: 1.25rem;
}

.micoapp-swiper-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1.25rem;
}

.micoapp-swiper-card {
    border-radius: 16px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #e5e7eb;
    transition: all 0.2s;
}
.micoapp-swiper-card:hover {
    border-color: #c5d4f0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.micoapp-swiper-card-inner {
    padding: 0.75rem;
}

.micoapp-swiper-preview {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    background: #f8fafc;
}

.micoapp-swiper-uploader ::v-deep .el-upload {
    display: block;
    width: 100%;
}

.micoapp-swiper-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 12px;
    cursor: pointer;
    overflow: hidden;
    transition: border-color 0.2s;
}
.micoapp-swiper-uploader .el-upload:hover {
    border-color: #409EFF;
}

.micoapp-swiper-img {
    width: 100%;
    aspect-ratio: 7 / 10;
    object-fit: cover;
    display: block;
}

.micoapp-swiper-placeholder {
    width: 100%;
    aspect-ratio: 7 / 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #94a3b8;
    background: #f1f5f9;
}
.micoapp-swiper-placeholder i {
    font-size: 2rem;
    margin-bottom: 0.5rem;
}
.micoapp-swiper-placeholder span {
    font-size: 0.8rem;
}

.micoapp-swiper-meta {
    margin-top: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}

.micoapp-swiper-sort {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}
.micoapp-swiper-label {
    font-size: 0.8rem;
    color: #6b7280;
}

.micoapp-swiper-actions {
    display: flex;
    align-items: center;
}
.micoapp-swiper-actions .el-button + .el-button {
    margin-left: 0.35rem;
}

.micoapp-home-empty {
    padding: 3rem 2rem;
    text-align: center;
    background: #f8fafc;
    border-radius: 16px;
    border: 1px dashed #e5e7eb;
}
.micoapp-home-empty i {
    font-size: 3rem;
    color: #cbd5e1;
}
.micoapp-home-empty p {
    margin: 0.75rem 0 0 0;
    color: #94a3b8;
    font-size: 0.9rem;
}

.text-danger {
    color: #f56c6c;
}
.text-danger:hover {
    color: #f78989;
}

@media (max-width: 576px) {
    .micoapp-swiper-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>
